/* eslint-disable max-len */
export default `# Privacy Policy  
**Last Updated: June 24, 2025**

**Virtual eTraining Software AB** is the creator and provider of the **TAGGIS QR** service and mobile application. This SERVICE is provided by Virtual eTraining Software AB and is intended for use as is.

This page informs users about our policies regarding the collection, use, and disclosure of personal information for those who choose to use our Service.

By using TAGGIS QR, you agree to the collection and use of information in accordance with this Privacy Policy. The personal information we collect is used solely for providing and improving the Service. We will not use or share your information with anyone except as described in this Privacy Policy.

---

## Information We Collect

### Personally Identifiable Information  
For a better experience, we may require you to provide us with certain personally identifiable information, such as:
- Name  
- Email address  
- Organization name  

This information is used solely for the purpose of user identification, support, and providing personalized service.

### Device and Technical Information  
We may collect technical data about your device, such as:
- Device model and operating system  
- App version and configuration  
- Unique device identifiers  

This helps us monitor performance and ensure compatibility.

### Crash Reports and Diagnostics  
In case of an error in the app or technical issue, we may collect:
- Device state and error logs  
- Time and date of the incident  
- App usage at the time of the issue  

This data is collected via third-party services to improve quality and stability.

### Camera and Photo Access  
We request access to:
- Your device’s camera for scanning QR codes  
- Your photo library for importing relevant QR images  

These permissions are only used for features that explicitly require them.

### Secure Local Storage  
To maintain user authentication and preferences, we securely store:
- Login/session tokens  
- User settings  
- Offline data for smoother user experience  

This data is stored only on your device and is not shared externally unless necessary.

### User Preferences and Offline Data  
We may store:
- App settings  
- Interaction history  
- Cached content  

This enhances your experience and reduces the need for constant server requests.

### Network Communication  
The app communicates with our servers to enable:
- User authentication  
- Synchronization of scanned QR data  
- Background syncing  

All transmissions are encrypted using industry standards (e.g., HTTPS).

### Media Playback and Document Display  
The app may allow you to view videos or documents (e.g., PDFs) for educational or operational use. These may be accessed online or stored locally.

### Background Processing  
The app performs limited background tasks, such as:
- Syncing content  
- Executing scheduled jobs (e.g., updates, queue processing)  

These are essential to ensure seamless functionality.

---

## Third-party Services

We may use third-party providers to help us:
- Analyze app usage  
- Report crashes  
- Securely store authentication data  
- Provide media display or document functionality  

Examples may include cloud services (e.g., AWS, Azure), analytics platforms, and mobile SDKs. These services are given only the minimum necessary data and are contractually bound to maintain security.

---

## Log Data

In the event of a crash or error while using our Service, we may collect information including:
- Your device’s IP address  
- Device name and OS version  
- Time and date of Service usage  
- App configuration at time of error  
- Other technical identifiers  

This is referred to as Log Data and is used for diagnostics only.

---

## Cookies

Although TAGGIS QR does not use cookies directly, some embedded third-party services may. These may store small amounts of data on your device to improve performance.

You may choose to refuse cookies via device settings, but this may limit some app functionality.

---

## Security

We value your trust and strive to use commercially acceptable methods to protect your personal information. However, no method of internet transmission or electronic storage is 100% secure, and we cannot guarantee absolute protection.

---

## Links to Other Sites

The app may contain links to external websites not operated by us. We strongly advise reviewing the privacy policies of those sites, as we have no control over and assume no responsibility for their practices.

---

## Children’s Privacy

This Service is not directed to anyone under the age of 13. We do not knowingly collect personally identifiable information from children. If we discover that a child under 13 has provided us with personal information, we will delete it immediately. If you are a parent or guardian and believe your child has submitted personal data, please contact us.

---

## Changes to This Privacy Policy

This policy may be updated periodically. Any changes will be posted on this page. We encourage you to review this page regularly.

---

## Contact Us

If you have any questions or concerns about this Privacy Policy or how TAGGIS QR handles your data, please contact us at:

**Email:** info@taggis.com   

**Address:** 
Virtual eTraining Software AB  
Hornsgatan 24, 118 20 Stockholm, Sweden

If you are not satisfied with our response, you may contact your local data protection authority.`;



// WEBPACK FOOTER //
// ./src/constants/content/languages/privacy-qr.js